import { ShFacet } from '../../elements/components/facet/entities/facet.entity';

export function sortFacetsByOrder(facets: ShFacet[], order: readonly string[] | null | undefined): ShFacet[] {
    if (!order || order.length === 0) {
        return facets;
    }

    const rankByKey: Map<string, number> = new Map(order.map((key, index) => [key, index]));

    return facets
        .map((facet, index) => ({ facet, index }))
        .sort((a, b) => {
            const rankA: number = rankByKey.get(a.facet.key) ?? Number.POSITIVE_INFINITY;
            const rankB: number = rankByKey.get(b.facet.key) ?? Number.POSITIVE_INFINITY;
            return rankA !== rankB ? rankA - rankB : a.index - b.index;
        })
        .map(entry => entry.facet);
}

/**
 * Folds a reordered *visible* list back into the full ranking. The panel hides filters that cannot narrow
 * the current list (HFBD-5), so the user drags a subset: a key the user could not see keeps its rank
 * relative to the neighbour it still has.
 */
export function mergeFacetRanking(oldFull: readonly string[], newVisibleOrder: readonly string[]): string[] {
    const visible: Set<string> = new Set(newVisibleOrder);
    const result: string[] = [...newVisibleOrder];
    const hidden: string[] = oldFull.filter(key => !visible.has(key));

    for (const key of hidden) {
        const oldIndex: number = oldFull.indexOf(key);
        let insertAfter: string | null = null;

        for (let j = oldIndex - 1; j >= 0; j--) {
            if (result.includes(oldFull[j])) {
                insertAfter = oldFull[j];
                break;
            }
        }

        if (insertAfter === null) {
            result.unshift(key);
        } else {
            result.splice(result.indexOf(insertAfter) + 1, 0, key);
        }
    }

    return result;
}
